import request from "@/utils/tycom-request";
import { getEnv } from "@/utils/env";

const getServiceName = () => {
  return getEnv("SERVICE_NAME", "site_user_center");
};

export async function getInfo() {
  return request({
    method: "GET",
    url: "/getInfo",
    serviceName: await getServiceName(),
  });
}

export async function addCurrentUserData(data) {
  return request({
    method: "POST",
    url: "/addCurrentUserData",
    serviceName: await getServiceName(),
    data,
  });
}

export async function getCurrentUserData(data) {
  return request({
    method: "POST",
    url: "/getCurrentUserData",
    serviceName: await getServiceName(),
    data,
  });
}

export async function getCurrentUserDataList(data) {
  return request({
    method: "POST",
    url: "/getCurrentUserDataList",
    serviceName: await getServiceName(),
    data,
  });
}

export async function delCurrentUserData(data) {
  return request({
    method: "POST",
    url: "/delCurrentUserData",
    serviceName: await getServiceName(),
    data,
  });
}
